import { RUTAS_CONFIG } from "../../core/auth/roles-url";
import { NavData } from "../../models/NavData";

export const navItemsPT: NavData[] = [
  {
    name: 'Dashboard',
    url: '/',
    icon: 'cil-speedometer'
  },
  // {
  //   name: 'Calendario',
  //   url: '/calendario',
  //   role: [],
  //   icon: 'cil-calendar'
  // },
  {
    name: 'Facturación',
    url: RUTAS_CONFIG.TICKETS.url,
    role: RUTAS_CONFIG.TICKETS.roles,
    icon: 'cil-euro'
  },
  {
    name: 'Clientes',
    url: RUTAS_CONFIG.CLIENTES.url,
    role: RUTAS_CONFIG.CLIENTES.roles,
    icon: 'cil-people'
  },
  {
    name: 'Bonos de Oohlalá',
    url: RUTAS_CONFIG.BONOS.url,
    role: RUTAS_CONFIG.BONOS.roles,
    icon: 'cil-money'
  },
  {
    name: 'Bonos de los clientes',
    url: RUTAS_CONFIG.BONOCLIENTES.url,
    role: RUTAS_CONFIG.BONOCLIENTES.roles,
    icon: 'cil-money'
  },
  {
    name: 'Cierre de Caja',
    url: RUTAS_CONFIG.CAJA_CIERRE.url,
    role: RUTAS_CONFIG.CAJA_CIERRE.roles,
    icon: 'cil-fax'
  },
  {
    name: 'Arqueo de Caja',
    url: RUTAS_CONFIG.CAJA_ARQUEO.url,
    role: RUTAS_CONFIG.CAJA_ARQUEO.roles,
    icon: 'cil-fax'
  },
  {
    name: 'Pagos Varios',
    url: RUTAS_CONFIG.PAGOS.url,
    role: RUTAS_CONFIG.PAGOS.roles,
    icon: 'cil-credit-card'
  },
  {
    name: 'Devoluciones',
    url: RUTAS_CONFIG.DEVOLUCIONES.url,
    role: RUTAS_CONFIG.DEVOLUCIONES.roles,
    icon: 'cil-action-undo'
  },
  {
    name: 'Productos',
    url: RUTAS_CONFIG.PRODUCTOS.url,
    role: RUTAS_CONFIG.PRODUCTOS.roles,
    icon: 'cil-cart'
  },
  {
    name: 'Tipo de Servicios',
    url: RUTAS_CONFIG.SERVICIOS_TIPOS.url,
    role: RUTAS_CONFIG.SERVICIOS_TIPOS.roles,
    icon: 'cil-settings'
  },
  {
    name: 'Servicios',
    url: RUTAS_CONFIG.SERVICIOS.url,
    role: RUTAS_CONFIG.SERVICIOS.roles,
    icon: 'cil-brush'
  },
  {
    name: 'Configuraciones',
    url: RUTAS_CONFIG.CONFIGURACIONES.url,
    role: RUTAS_CONFIG.CONFIGURACIONES.roles,
    icon: 'cil-settings'
  },
  {
    name: 'Gestión de usuarios',
    url: RUTAS_CONFIG.USUARIOS.url,
    role: RUTAS_CONFIG.USUARIOS.roles,
    icon: 'cil-user'
  },
  {
    name: 'Tiendas',
    url: RUTAS_CONFIG.TIENDAS.url,
    role: RUTAS_CONFIG.TIENDAS.roles,
    icon: 'cil-home'
  },
  {
    name: 'Informes',
    url: RUTAS_CONFIG.INFORMES.url,
    role: RUTAS_CONFIG.INFORMES.roles,
    icon: 'cil-bar-chart'
  },
  {
    name: 'Albaranes',
    url: RUTAS_CONFIG.ALBARANES.url,
    role: RUTAS_CONFIG.ALBARANES.roles,
    icon: 'cil-list-rich'
  },
  // {
  //   name: 'Envío SMS',
  //   url: '/enviosms',
  //   role: ['ROLE_ADMIN', 'ROLE_DES_ADMIN', 'ROLE_DES_GOD'],
  //   icon: 'cil-mobile'
  // },


  //  {
  //    name: 'Desarrollo',
  //    url:'/desarrollo',
  //    role: ['ROLE_DES_GOD'],
  //    icon:'cil-settings'
  //  }
];

